define('common/js/lib/Serum.CookieStore',[], function () {
  'use strict';

  function getCookie (key) {
    var values = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return values ? values.pop() : '';
  }
  /** @interface */
  return {
    getCookie: getCookie
  };

});

